// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.listingconversation.leadmanagement.RentalManagerLeadManagementWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ListingAlias,
  RentalManagerConversationSearchRequestDto,
  RentalManagerLeadManagementCountsResponseDto,
  RentalManagerLeadManagementSearchResponseDto,
  RentalManagerLeadManagementStatsDto,
  RentalManagerLeadManagementTableResponseDto,
} from '../..';

interface LeadManagementCountsParams {
  folder?: string;
  includePhoneLeads?: boolean;
  listingAlias: ListingAlias;
  minCriteriaMatches?: number;
  readRepliedStatus?: string;
  renterProgressStatus?: string;
}
interface LeadManagementStatsParams {
  listingAlias: ListingAlias;
}
interface LeadManagementTableParams {
  clientTimeZone: string;
  conversationId?: number;
  folder?: string;
  includePhoneLeads?: boolean;
  limit?: number;
  listingAlias?: ListingAlias;
  minCriteriaMatches?: number;
  readRepliedStatus?: string;
  renterProgressStatus?: string;
  start?: number;
}

export const RentalManagerLeadManagementWebApiHandler_leadManagementCounts_Path =
  '/api/web/v1/users/listingConversation/leadManagement/leadManagementCounts';

/**
 * Get lead counts from the lead management table
 */
export const RentalManagerLeadManagementWebApiHandler_leadManagementCounts = (
  getParams: LeadManagementCountsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<LeadManagementCountsParams, never, RentalManagerLeadManagementCountsResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerLeadManagementWebApiHandler_leadManagementCounts_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerLeadManagementWebApiHandler_leadManagementSearch_Path =
  '/api/web/v1/users/listingConversation/leadManagement/leadManagementSearch';

/**
 * Renter search results with screening criteria match data
 */
export const RentalManagerLeadManagementWebApiHandler_leadManagementSearch = (
  postData: RentalManagerConversationSearchRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    RentalManagerConversationSearchRequestDto,
    RentalManagerLeadManagementSearchResponseDto
  >(
    {
      endpoint: RentalManagerLeadManagementWebApiHandler_leadManagementSearch_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerLeadManagementWebApiHandler_leadManagementStats_Path =
  '/api/web/v1/users/listingConversation/leadManagement/leadManagementStats';

export const RentalManagerLeadManagementWebApiHandler_leadManagementStats = (
  getParams: LeadManagementStatsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<LeadManagementStatsParams, never, RentalManagerLeadManagementStatsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerLeadManagementWebApiHandler_leadManagementStats_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerLeadManagementWebApiHandler_leadManagementTable_Path =
  '/api/web/v1/users/listingConversation/leadManagement/leadManagementTable';

/**
 * Get tabular data for Lead Management table
 */
export const RentalManagerLeadManagementWebApiHandler_leadManagementTable = (
  getParams: LeadManagementTableParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<LeadManagementTableParams, never, RentalManagerLeadManagementTableResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerLeadManagementWebApiHandler_leadManagementTable_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
